import { useMutation } from '@tanstack/react-query';

import {
  useRequest,
  type MutationFunction,
  type MutationFunctionContext,
  type RequestQueryObject,
} from '@frontend/api';

const useRegenerateRequirementsReviewKey = [
  'rules',
  'regenerate_reqs_review',
] as const;
export const getUseRegenerateRequirementsReviewKey = () =>
  useRegenerateRequirementsReviewKey;

export type RegenerateRequirementsReviewRequestBody =
  | {
      componentId: string;
    }
  | { quoteItemId: string }
  | { quoteId: string };

/**
 * Mutation function for regenerating requirements review actions for a component.
 */
export const useRegenerateRequirementsReview: MutationFunction<
  { message: string },
  RegenerateRequirementsReviewRequestBody,
  [],
  RequestQueryObject
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation<
    { message: string },
    unknown,
    RegenerateRequirementsReviewRequestBody,
    MutationFunctionContext<{ message: string }>
  >({
    mutationFn: (body) =>
      request<{ message: string }>(`/rules/regenerate_reqs_review/`, {
        init: {
          method: 'POST',
          body,
        },
      }),
    ...queryOptions,
    mutationKey: getUseRegenerateRequirementsReviewKey(),
  });
};
